import { useGlobalContext } from '../context'
import React from 'react'

const CartItem = () => {
    const { dropdown, removePlayer } = useGlobalContext();
    return (
        <React.Fragment>
            {
                dropdown.map((player, index) => {
                    return (
                        <div key={index} id="cart item" className="cart-item d-flex justify-content-between text-capitalize my-3 mr-3 p-3 bg-dark rounded border border-light">
                            <img  src={`./img/${player.path}.png`} className="img-fluid rounded-circle small" id="item-img" alt=""/>
                            <div className="cart-item-text">
                                <p id="cart-item-title" className="font-weight-bold mb-0">{player.name}</p>
                                <span>$</span>
                                <span id="cart-item-price" className="cart-item-price mb-0">{player.price}</span>
                            </div>
                            <a href='/#'><i onClick={removePlayer} id='cart-item-remove' className="fas fa-trash cart-item-remove mt-3"></i></a>
                        </div>
                    )
                })
            }
        </React.Fragment>
        
    )
}

export default CartItem